import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from 'react-bootstrap/Button';
import {Turn, Shop, Neighbourhood, Zone} from "./types";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from 'react-bootstrap';

const axios = require("axios").default;

function New() {
  const [shops, setShops] = useState<Shop[]>([]);
  const [turns, setTurns] = useState<Turn[]>([]);
  const [zones, setZones] = useState<Zone[]>([]);
  const [zone, setZone] = useState("");
  const [turn, setTurn] = useState("");
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchedTurns, setFetchedTurns] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const location = useLocation().state as {userId: string};
  const [neighbourhoods, setNeighbourhoods] = useState<Neighbourhood[]>([]);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  useEffect(() => {
    axios.get("https://europe-west1-gran-recogida.cloudfunctions.net/api/barrios/recsYAhN7Za0MYXIi")
    .then((data: any) => {
      setNeighbourhoods(data.data);
    })
    .catch((err: any) => {
      console.log(err);
    });
  }, []);
  const neighbourhoodOptions = neighbourhoods.map((neighbourhood) => 
    <option key={neighbourhood.id} value={neighbourhood.id}>{neighbourhood.name}</option>
  );
  let shopOptions = shops.map((shop) => 
    <option key={shop.id} value={shop.id}>{shop.name}</option>
  );
  const turnOptions = turns.map((turn) => 
    <option key={turn.id} value={turn.id}>{turn.date} - {turn.turn} (plazas libre: {turn.plazasLibres})</option>
  );
  const zoneOptions = zones.map((zone) => 
    <option key={zone.id} value={zone.id}>{zone.name}</option>
  );
  const fetchShops = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLoading(true);
    setTurns([]);
    setShops([]);
    setFetchedTurns(false);
    axios.get(`https://europe-west1-gran-recogida.cloudfunctions.net/api/sites/${event.target.value}`)
    .then((data: any) => {
      setShops(data.data);
      setLoading(false);
    })
    .catch();
  };
  const fetchTurns = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLoading(true);
    axios.get(`https://europe-west1-gran-recogida.cloudfunctions.net/api/turns/${event.target.value}`)
    .then((data: any) => {
      setTurns(data.data);
      setLoading(false);
      setFetchedTurns(true);
    })
    .catch();
  };
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setSubmitDisabled(true);
    event.preventDefault();
    await axios.post("https://europe-west1-gran-recogida.cloudfunctions.net/api/turns",{
        turn_id: turn,
        user_id: location.userId, 
        zone_id: zone,
      })
    .then((data: any) => {
      setShowSuccess(true);
    })
    .catch((error: any) => {
      console.log(error);
      setErrors("Ha sido un error enviando");
    })
  }
  return (
            // TODO add validation
    <div className="justify-content-md-center m-5">
      {showSuccess && 
        <Row>
          <Col>
            <p>¡MUCHAS GRACIAS por querer participar como voluntario/a en esta GRAN RECOGIDA DE ALIMENTOS 2023!</p>
            <p>No olvides visitar <a href="www.bancoalimentosgranada.org">www.bancoalimentosgranada.org</a>, donde encontrarás toda la información sobre esta campaña y los manuales de formación, de lectura obligatoria.</p>
            <p>Para cualquier dificultad que tengas y siempre que lo desees, puedes contactar con el equipo central en el teléfono 638204929 (llamada o whatsapp) o en el correo <a href="mailto:granrecogida@bancoalimentosgranada.org">granrecogida@bancoalimentosgranada.org</a>.</p>
            <p>Síguenos también en Facebook, Twitter e Instagram.</p>
            <p>¡HASTA PRONTO!</p>
            <Link to="/">Mis turnos</Link>
          </Col>
        </Row>
      }
      {!showSuccess && 
        <Form onSubmit={handleSubmit}>
          {neighbourhoods.length > 0 && 
            <Row>
              <Col className="mt-3">
                <p>Recuerda que puedes inscribirte en todas las tiendas que desees y en todos los turnos desees. No hay límite máximo.</p>
              </Col>
            </Row>
          }
          <Row>
            {neighbourhoods.length > 0 && <Col className='col-sm-6 col-12'>
                <Form.Label>Barrio:</Form.Label>
                <Form.Select onChange={fetchShops}>
                  <option>Elige tu barrio</option>
                  {neighbourhoodOptions}
                </Form.Select>
              </Col> }

            {shops.length > 0 && <Col className='col-sm-6 col-12'>
                <Form.Label>Tienda:</Form.Label>
                <Form.Select onChange={fetchTurns}>
                  <option>Elige tu tienda</option>
                  {shopOptions}
                </Form.Select>
              </Col>}
          </Row>
          <Row>
            {turns.length > 0 && <Col>
              <Form.Label>Turno:</Form.Label>
              <Form.Select onChange={(e) => {setTurn(e.target.value); setSubmitDisabled(false)}}>
                <option>Elige tu turno</option>
                {turnOptions}
              </Form.Select>
            </Col>}
            {turns.length === 0 && fetchedTurns && <Col>
              <p>No quedan turnos disponibles en esta tienda.</p>
            </Col>}
          </Row>
          <Row>
            {loading &&
              <Col className="mt-3">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
              </Col>
            }
          </Row>
          <Row>
            <Col className="mt-3">
              {errors && <Alert variant="danger">{errors}</Alert>}
              <Button variant="primary" type="submit" disabled={submitDisabled}>
                Enviar
              </Button>
            </Col>
          </Row>
        </Form>
      }
    </div>
  );
}

export default New;
